import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { balanceReducer } from '../reducers/balanceReducer';
import { modalMovReducer } from '../reducers/modalMovReducer';
import { noneReducer } from '../reducers/noneReducer';
import { pinesReducer } from '../reducers/pinesReducer';
import { saleReducer } from '../reducers/saleReducer';
import { uiReducer } from '../reducers/uiReducer';
import { pdvInfoReducer } from '../reducers/pdvInfoReducer';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const reducers = combineReducers({
    noneState: noneReducer,
    balanceState: balanceReducer,
    uiState: uiReducer,
    saleState: saleReducer,
    modalMovState: modalMovReducer,
    pinesState: pinesReducer,
    pdvInfoState: pdvInfoReducer
});

export const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(thunk)
    )
);